import React from "react";
import { useMedia } from "react-use";
import SpeedItem from "../modules/SpeedItem";
import PropTypes from "prop-types";
import Carousel, {consts} from "react-elastic-carousel";
import globals from "../globals";

const NbnSpeeds = (props) => {    
    const isTablet = useMedia("(min-width: 750px) and (max-width: 991px)");
    const isDesktop = useMedia("(min-width: 992px)");

    const SpeedItems = props.plans.map((plan, key) => {
        return (
            <SpeedItem
                key={key}
                plan={plan}
                position={key}
                planDescription={globals.convertTitle(plan.planSpeed)}
                id={plan.id}
                isPhoneIncluded={props.isPhoneIncluded}
                selectedContractName={props.selectedContractName}
                active={plan === props.selectedPlan ? "active" : ""}
                handleChangeSpeed={props.handleChangeSpeed.bind(this)}
                upfrontTotal={props.upfrontTotal}
                calcMonthlyPrice={props.calcMonthlyPrice}
                calcPrice={props.calcPrice}
                isRecommendedPlan={props.recommendedPlan === plan}
            />
        );
    });

    const CarouselMobile = (
        <Carousel
            className="compare-plan-smb"
            itemsToShow={1}            
            showArrows={true}
            children={SpeedItems}
            itemPosition={consts.CENTER}
            outerSpacing={30}
            pagination={false}
        />
    );

    const CarouselTablet = (
        <Carousel
            className="compare-plan-smb"
            itemsToShow={2}            
            showArrows={true}
            children={SpeedItems}
            itemPosition={consts.CENTER} 
            outerSpacing={30}
            pagination={false}
        />
    );

    const CarouselDesktop = (
        <Carousel
            className="compare-plan-smb"
            itemsToShow={4}
            showArrows={true}
            children={SpeedItems}
            itemPosition={consts.CENTER}
            outerSpacing={40}
            pagination={false}
        />
    );

    return (
        <div className="nbn-speeds">
            <div className={`speeds-inner ${props.plans.length > 3 ? 'justify-content-between' : 'justify-content-start'}`}>{isDesktop ? CarouselDesktop : (isTablet ? CarouselTablet : CarouselMobile)}</div>
        </div>
    );
};

NbnSpeeds.propTypes = {
    plans: PropTypes.array.isRequired,
    selectedPlan: PropTypes.object.isRequired,
};

export default NbnSpeeds;



// WEBPACK FOOTER //
// ./resources/assets/js/nbn/NbnSpeeds.js